import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';

import { HomePageService } from 'src/app/homepage/homepage.service';
import {UpdateSubjectsServices} from './update-subjects.service';

@Component({
  selector: 'app-update-subjects',
  templateUrl: './update-subjects.component.html',
  styleUrls: ['./update-subjects.component.css']
})
export class UpdateSubjectsComponent implements OnInit {
  isSubjectsLoading: boolean;
  subjectHeading: string = '';
  subjectSubheadings: string[] = [];

  subjectsList: any[] = [];
  selectedSubjectId = '';
  selectedSubjectTitle = '';
  selectedSubjectSubtopic1 = '';
  selectedSubjectSubtopic2 = '';
  selectedSubjectSubtopic3 = '';
  selectedSubjectSubtopic4 = '';
  selectedSubjectSubtopic5 = '';
  selectedSubjectSubtopic6 = '';
  selectedSubjectSubtopic7 = '';
  selectedSubjectSubtopic8 = '';

  constructor(
    private updateSubjectsServices: UpdateSubjectsServices,
    private homePageService: HomePageService
  ) { }

  ngOnInit(): void {
    this.isSubjectsLoading = false;
    this.listAllSubjects();
  }

  onAdd() {
    this.updateSubjectsServices.createSubject({
      title: this.subjectHeading,
      details: this.subjectSubheadings
    }).subscribe(() => {
      Swal.fire('Subject added successfully!');
      this.listAllSubjects();
    });
    this.subjectHeading = '';
    this.subjectSubheadings = [];
  }

  onDelete(subjectId: string) {
    this.selectedSubjectId = subjectId;
  }

  onDeleteConfirm() {
    this.updateSubjectsServices.deleteSubject({ Id: this.selectedSubjectId }).subscribe(() => {
      Swal.fire('Subject deleted successfully!');
      this.listAllSubjects();
    });
  }

  onUpdate(subject: any) {
    this.selectedSubjectId = subject._id;
    this.selectedSubjectTitle = subject.title;
    this.selectedSubjectSubtopic1 = subject.details[0];
    this.selectedSubjectSubtopic2 = subject.details[1];
    this.selectedSubjectSubtopic3 = subject.details[2];
    this.selectedSubjectSubtopic4 = subject.details[3];
    this.selectedSubjectSubtopic5 = subject.details[4];
    this.selectedSubjectSubtopic6 = subject.details[5];
    this.selectedSubjectSubtopic7 = subject.details[6];
    this.selectedSubjectSubtopic8 = subject.details[7];
  }

  onUpdateConfirm() {
    this.updateSubjectsServices.updateSubject({
      Id: this.selectedSubjectId,
      title: this.selectedSubjectTitle,
      details: [
        this.selectedSubjectSubtopic1,
        this.selectedSubjectSubtopic2,
        this.selectedSubjectSubtopic3,
        this.selectedSubjectSubtopic4,
        this.selectedSubjectSubtopic5,
        this.selectedSubjectSubtopic6,
        this.selectedSubjectSubtopic7,
        this.selectedSubjectSubtopic8
      ]
    }).subscribe(() => {
      Swal.fire('Subject updated successfully!');
      this.listAllSubjects();
    })
  }

  listAllSubjects() {
    this.isSubjectsLoading = true;
    this.homePageService.subjectsList().subscribe((data: any) => {
      this.subjectsList = data.subjectList;
      this.isSubjectsLoading = false;
    });
  }

}
